<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom" class="infoForm">
        <el-form-item
          label="角色名称"
          prop="name"
          :rules="[
            { required: true, message: '请填写角色名称', trigger: 'blur' },
          ]"
        >
          <el-input v-model="state.model.name"></el-input>
        </el-form-item>
        <el-form-item label="角色说明">
          <el-input
            type="textarea"
            v-model="state.model.description"
          ></el-input>
        </el-form-item>
        <template v-if="props.id">
          <el-form-item label="创建时间">
            <el-input v-model="state.model.create_time" disabled></el-input>
          </el-form-item>
          <el-form-item label="修改时间">
            <el-input v-model="state.model.update_time" disabled></el-input>
          </el-form-item>
        </template>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { role_add, role_edit, role_detail } from "@/http/adminrole";
import { post_response } from "@/utils/qFormat";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1 },
    });
    onMounted(() => {
      if (props.id) {
        role_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;
            if (state.model.pid == 0) delete state.model.pid;
          }
        });
      }
    });

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            role_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            role_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
    };
  },
};
</script>
<style scoped lang="less"></style>
